import { jsx as _jsx } from "react/jsx-runtime";
import { ProductPreviewThumbSlide, Carousel, CarouselVariant, SliderNavVariant, SliderNavDirection, } from '@as/cotopaxi';
import { ProductImageSizesPortraitEnum } from '@as-react/common-types';
import { Breakpoint } from '@yonderland/andes-react';
import { useState, useEffect, useCallback } from 'react';
import { MIN_SCREEN_WIDTH_DESKTOP, MIN_SCREEN_WIDTH_DESKTOP_LARGE } from '../../../../constants/ScreenWidthConstants';
const ProductPreviewThumbSlider = ({ activeSlideIndex, mediaCollection, onActiveSlideIndexChange, alt, }) => {
    const [gallerySwiper, setGallerySwiper] = useState(null);
    useEffect(() => {
        var _a;
        if (gallerySwiper !== null && !!activeSlideIndex) {
            if (((_a = gallerySwiper.slides[activeSlideIndex]) === null || _a === void 0 ? void 0 : _a.className.indexOf('swiper-slide-visible')) < 0) {
                gallerySwiper.slideTo(activeSlideIndex);
            }
        }
    }, [activeSlideIndex]);
    useEffect(() => {
        gallerySwiper === null || gallerySwiper === void 0 ? void 0 : gallerySwiper.update();
    }, [mediaCollection]);
    const onThumbClick = (index) => {
        if (index !== activeSlideIndex) {
            onActiveSlideIndexChange(index);
        }
    };
    const renderSlide = useCallback((image, index) => (_jsx("div", { onClick: () => onThumbClick(index), children: _jsx(ProductPreviewThumbSlide, { active: activeSlideIndex === index, isVideo: image.isVideo, imagePath: image.sourceSet[ProductImageSizesPortraitEnum.thumb], alt: alt }) }, `image_${index}`)), [activeSlideIndex]);
    const productThumbSliderCarouselConfig = {
        variant: CarouselVariant.THUMB,
        arrowsConfig: {
            variant: SliderNavVariant.SEMICIRCLE,
            direction: SliderNavDirection.VERTICAL,
        },
        configurationOverrides: {
            autoHeight: true,
            noSwiping: true,
            getSwiper: setGallerySwiper,
            direction: 'vertical',
            breakpoints: {
                [MIN_SCREEN_WIDTH_DESKTOP]: {
                    slidesPerGroup: 5,
                    slidesPerView: 5,
                    height: 540,
                },
                [MIN_SCREEN_WIDTH_DESKTOP_LARGE]: {
                    slidesPerGroup: 6,
                    slidesPerView: 6,
                    height: 822,
                },
            },
            spaceBetween: 23,
        },
    };
    return (_jsx(Breakpoint, { from: "lg", children: _jsx(Carousel, Object.assign({}, productThumbSliderCarouselConfig, { dataQA: "product_thumb_slider", children: mediaCollection.map((image, index) => renderSlide(image, index)) })) }));
};
export default ProductPreviewThumbSlider;
